import type { IconSize, RIconComponent } from '@ben/orion/remix-icon';
import RIcon from '@ben/orion/remix-icon';
import Tooltip from '@ben/orion/tooltip';
import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface IconCellProps {
  children: ReactNode;
  icon?: RIconComponent | string;
  iconTooltipText?: string;
  iconColor?: string;
  showIcon?: boolean;
  iconDataTestid?: string;
  className?: string;
  isRightIcon?: boolean;
  iconSize?: IconSize;
}

const IconCell = ({
  children,
  icon,
  iconTooltipText,
  iconColor,
  showIcon = false,
  iconDataTestid,
  className,
  isRightIcon = false,
  iconSize = 'sm',
}: IconCellProps) => {
  if (!showIcon || !icon) {
    return children;
  }
  return (
    <Tooltip tooltipText={iconTooltipText}>
      <Wrapper data-testid={iconDataTestid} className={className}>
        {!isRightIcon && (
          <IconWrapper>
            <RIcon icon={icon} size={iconSize} color={iconColor} />
          </IconWrapper>
        )}
        {children}
        {isRightIcon && (
          <IconWrapper>
            <RIcon icon={icon} size={iconSize} color={iconColor} />
          </IconWrapper>
        )}
      </Wrapper>
    </Tooltip>
  );
};

export default IconCell;

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacing(1.5)};
  `}
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
`;
